module.exports = __webpack_public_path__ + "img/right.57b16bf5.png";